<div class="score-drawing" fxFlexFill fxLayout="column" fxLayoutGap="20px">
  <div fxLayoutAlign="center center">{{answer.questionRef.text}}</div>
  <div fxFlex="350px" fxLayoutAlign="center center">
    <canvas #canvasElement [width]="500" [height]="350"></canvas>
  </div>
</div>
